export default __webpack_public_path__ + "6d7c3a75dc7aec8ef01f9d0c0d4d4601.png";